import { createContext } from 'react';

type ICommonContext = {
  disableElement: boolean;
  setDisableElement: (value: boolean) => void;
  disableNavigation: boolean;
  setDisableNavigation: (value: boolean) => void;
  modalWarningOpen: boolean;
  setModalWarningOpen: (value: boolean) => void;
};

export const CommonContext = createContext<ICommonContext>({
  disableElement: false,
  setDisableElement: () => {
    console.warn('setDisableElement is called');
  },
  disableNavigation: false,
  setDisableNavigation: () => {
    console.warn('setDisableNavigation is called');
  },
  modalWarningOpen: false,
  setModalWarningOpen: () => {
    console.warn('setModalWarningOpen is called');
  },
});
